module.exports = __webpack_public_path__ + "eac34d9ca3c1a3470f7e87fd262c8631.svg";